(function () {
  'use strict';

  function isDesktop() {
    return window.matchMedia('(min-width: 900px)').matches;
  }

  function mod(n, count) {
    return ((n % count) + count) % count;
  }

  function wrapDelta(delta, count) {
    if (count < 2) return delta;
    if (delta > count / 2) delta -= count;
    if (delta < -count / 2) delta += count;
    return delta;
  }

  function init(root) {
    if (!root || root._sel2LovedBound) return;
    var viewport = root.querySelector('[data-sel-2-review-glider]');
    var dots = root.querySelector('[data-sel-2-review-dots]');
    var prev = root.querySelector('[data-sel-2-review-prev]');
    var next = root.querySelector('[data-sel-2-review-next]');
    if (!viewport) return;
    var slides = Array.prototype.slice.call(viewport.querySelectorAll('[data-sel-2-review-slide]'));
    if (!slides.length) return;
    root._sel2LovedBound = true;

    var index = slides.length > 2 ? 1 : 0;
    var lastDeltas = [];
    var startX = 0;
    var dragging = false;

    if (dots) {
      dots.innerHTML = '';
      slides.forEach(function (_, i) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.setAttribute('aria-label', 'Show review ' + (i + 1));
        btn.addEventListener('click', function () { go(i); });
        dots.appendChild(btn);
      });
    }

    function go(nextIndex) {
      index = mod(nextIndex, slides.length);
      layout();
    }

    function layout() {
      var desktop = isDesktop();
      var count = slides.length;
      var stageWidth = viewport.clientWidth || viewport.parentElement.clientWidth || 320;
      var gap = 16;
      var slideWidth = desktop ? (stageWidth - gap * 2) / 3 : Math.round(stageWidth * 0.78);
      var tallest = 0;
      var jumps = [];

      slides.forEach(function (slide, i) {
        var delta = wrapDelta(i - index, count);
        var prevDelta = lastDeltas[i];
        var jumped = prevDelta != null && Math.abs(delta - prevDelta) > 1;
        var focused = delta === 0;
        var visible = Math.abs(delta) <= 1;
        var x = (stageWidth - slideWidth) / 2 + delta * (slideWidth + gap);
        slide.style.width = slideWidth + 'px';
        slide.style.left = '0px';
        slide.style.top = '50%';
        if (jumped) slide.style.transition = 'none';
        slide.style.visibility = visible ? 'visible' : 'hidden';
        slide.style.pointerEvents = visible ? 'auto' : 'none';
        slide.style.zIndex = focused ? '2' : '1';
        slide.style.opacity = focused ? '1' : (visible ? '0.45' : '0');
        slide.style.transform = 'translate(' + x + 'px, -50%) scale(' + (focused ? '1.06' : '0.9') + ')';
        slide.classList.toggle('is-current', focused);
        lastDeltas[i] = delta;
        jumps.push(jumped);
        if (visible) tallest = Math.max(tallest, slide.offsetHeight);
      });

      if (jumps.some(Boolean)) viewport.offsetHeight;
      slides.forEach(function (slide, i) {
        if (jumps[i]) slide.style.transition = '';
      });

      viewport.style.height = Math.ceil(tallest * 1.08 + 8) + 'px';
      if (dots) {
        Array.prototype.forEach.call(dots.children, function (dot, i) {
          dot.classList.toggle('is-active', i === index);
        });
      }
      if (prev) prev.disabled = false;
      if (next) next.disabled = false;
    }

    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); go(index - 1); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); go(index + 1); });

    viewport.addEventListener('pointerdown', function (e) {
      if (e.target.closest('a, button')) return;
      dragging = true;
      startX = e.clientX;
    });
    viewport.addEventListener('pointerup', function (e) {
      if (!dragging) return;
      dragging = false;
      var delta = e.clientX - startX;
      if (Math.abs(delta) > 40) go(index + (delta < 0 ? 1 : -1));
    });
    viewport.addEventListener('pointercancel', function () { dragging = false; });

    window.addEventListener('resize', layout);
    window.addEventListener('load', layout);
    slides.forEach(function (slide) {
      var img = slide.querySelector('img');
      if (img && !img.complete) img.addEventListener('load', layout);
    });
    layout();
  }

  function boot() {
    document.querySelectorAll('[data-sel-2-loved-reviews]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-sel-2-loved-reviews]');
    if (root) {
      delete root._sel2LovedBound;
      init(root);
    }
  });
})();
